import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const ThankYouEmailCategory = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
        <Typography>{t('share_document_v3.automatic_reminders.send')}</Typography>
        <Autocomplete
          size="small"
          sx={{ width: '100%' }}
          options={[]}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('share_document_v3.automatic_reminders.thank_you_email_category.thank_you_email_default_template')}
            />
          )}
        />
      </Stack>
      <Stack>
        <Typography>{t('share_document_v3.automatic_reminders.thank_you_email_category.after_document_is_signed')}</Typography>
      </Stack>
    </Stack>
  );
};
